import React, { useState } from 'react';
import { View } from 'react-native';
import { Image } from 'expo-image';
import { useTheme } from '@/context/ThemeContext';
import { useAgentStore } from '@/store';
import Icon from '@/components/Icon';

export default function TaskAvatar({ task, size = 40 }) {
  const { colors } = useTheme();
  const [failedUri, setFailedUri] = useState(null);
  const agent = useAgentStore(state => task?.agentId ? state.agents[task.agentId] : undefined);
  const uri = task?.agentId ? task.agentAvatarPath || agent?.avatarPath : null;
  const style = { width: size, height: size, borderRadius: size / 4, flexShrink: 0 };
  if (uri && uri !== failedUri) {
    return <Image
      source={{ uri }}
      style={style}
      contentFit="cover"
      accessibilityLabel={task.agentName || agent?.name || undefined}
      recyclingKey={uri}
      onError={() => setFailedUri(uri)}
    />;
  }
  return (
    <View style={[style, { backgroundColor: colors.solid_color_secondary, alignItems: 'center', justifyContent: 'center' }]}>
      <Icon name={task?.agentId ? 'robot' : task?.template?.icon || 'clipboard-list'} size={size / 2} color={colors.text_color_secondary} />
    </View>
  );
}
